import { Box, Button, Progress, Typography } from "@carrotfertility/carotene-core"
import { BookingCard } from "./BookingCard"
import React from "react"

export function ConfirmingBookingPage({ onRetry }: { onRetry?: () => void }): JSX.Element {
  return (
    <Box sx={(theme) => ({ display: "flex", flexDirection: "column", gap: theme.spacing(theme.tokens.spacing.sm) })}>
      <BookingCard>
        <Typography variant="h4" component="h1">
          Confirming payment method and booking appointment
        </Typography>
        <Typography variant="body1">This may take a moment. Please don’t reload or close this page.</Typography>
        {onRetry ? (
          <Box>
            <Button color="secondary" variant="contained" onClick={onRetry}>
              Try again
            </Button>
          </Box>
        ) : (
          <Box
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              blockSize: 500,
              padding: theme.spacing(theme.tokens.spacing.lg)
            })}
          >
            <Progress aria-label="Confirming your booking" />
          </Box>
        )}
      </BookingCard>
    </Box>
  )
}
